module.exports = __webpack_public_path__ + "img/error_404.09249db.png";